import { ManagerVehicles } from "./models/manager-vehicles";
export function getFormatter() {
    const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency', currency: 'USD', minimumFractionDigits: 0, maximumFractionDigits: 0
    });
    return function (value) {
        if (!value) {
            value = 0;
        }
        return formatter.format(value);
    };
}
export function getSelectedCity() {
    const tmp = localStorage.getItem('selectedCity');
    if (tmp) {
        try {
            const { id } = JSON.parse(tmp);
            return id;
        }
        catch (e) {
        }
    }
    return '11001';
}
export function getCity() {
    try {
        const tmp = JSON.parse(localStorage.getItem('selectedCity'));
        return tmp ? tmp : {
            id: '11001',
            name: 'Bogotá D.C.'
        };
    }
    catch (e) {
        return {
            id: '11001',
            name: 'Bogotá D.C.'
        };
    }
}
export function getCookie(name) {
    let cookieValue = null;
    if (document.cookie && document.cookie !== '') {
        const cookies = document.cookie.split(';');
        for (let i = 0; i < cookies.length; i++) {
            const cookie = cookies[i].trim();
            // Does this cookie string begin with the name we want?
            if (cookie.substring(0, name.length + 1) === (name + '=')) {
                cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
                break;
            }
        }
    }
    return cookieValue;
}
export function isFavorite(data) {
    const jsonData = localStorage.getItem('favoritos');
    if (jsonData) {
        const favorites = JSON.parse(jsonData);
        return !!favorites.find(f => f.item_id === data.referencia && f.item_type === data.type);
    }
    return false;
}
export function getCodModeloTasa(car = undefined) {
    const selected = ManagerVehicles.getInstance().selected;
    if (selected) {
        return selected.codModeloTASA;
    }
    else if (car === null || car === void 0 ? void 0 : car.cod_modelo_tasa) {
        return car.cod_modelo_tasa;
    }
    else {
        return 'N17';
    }
}
export function setFlag(price) {
    const container = document.getElementById('flag-container');
    if (container && (price === null || price === void 0 ? void 0 : price.porcDescuento) > 0) {
        const div = document.createElement('div');
        div.setAttribute('class', 'discount-flag absolute');
        div.textContent = `DESCUENTO ${price.porcDescuento}%`;
        container.textContent = '';
        container.appendChild(div);
    }
}
export function getCodToAccessory(linea = null) {
    var _a;
    const selected = ManagerVehicles.getInstance().selected;
    return selected ? selected.codModeloTASA : ((_a = linea === null || linea === void 0 ? void 0 : linea.cod_modelo_tasa) !== null && _a !== void 0 ? _a : 'N17');
}
export function getQueryParams() {
    const searchParams = new URLSearchParams(window.location.search);
    const filters = {};
    for (const key of searchParams.keys()) {
        filters[key] = [];
    }
    Object.keys(filters).forEach((key) => {
        filters[key] = searchParams.getAll(key);
    });
    return {
        filters: Object.keys(filters).reduce((acc, slug) => {
            var _a;
            acc.push({
                slug,
                options: (_a = filters[slug]) !== null && _a !== void 0 ? _a : []
            });
            return acc;
        }, []),
        aux: filters
    };
}
export function pushState(filters) {
    const url = new URL(`${window.location.origin}${window.location.pathname}`);
    filters.forEach((item) => {
        item.options.forEach((o) => {
            url.searchParams.append(item.slug, o);
        });
    });
    window.history.pushState({}, '', url);
}
export const parseFetch = (params) => {
    const headers = {
        'X-CSRFToken': getCookie('csrftoken')
    };
    if (!(params.data instanceof FormData)) {
        headers['Content-Type'] = 'application/json';
    }
    const options = {
        method: params.method,
        mode: 'cors',
        cache: 'no-cache',
        credentials: 'same-origin',
        headers: Object.assign({}, headers),
        body: params.data instanceof FormData ? params.data : JSON.stringify(params.data)
    };
    const url = new URL(params.url, location.origin);
    if (params.method.toLowerCase() === 'get') {
        delete options.body;
        if (params.data instanceof URLSearchParams) {
            url.search = params.data.toString();
        }
        else {
            url.search = new URLSearchParams(params.data).toString();
        }
    }
    return new Promise((resolve, reject) => {
        fetch(url.toString(), options).then((response) => {
            if (response.ok) {
                response.json().then((data) => {
                    resolve(data);
                }).catch(() => {
                    reject();
                });
            }
            else {
                response.json().then((body) => {
                    reject(body);
                }).catch(() => {
                    reject();
                });
            }
        }).catch(() => {
            reject();
        });
    });
};
